module.exports = __webpack_public_path__ + "img/DIENTE_SANO.png";